import Tracker from './Tracker';

const Image = ({url, title, onLoad}) => (
    <Tracker onLoad={onLoad}>
        {onLoad => <img src={url} alt={title} onLoad={onLoad} onError={onLoad} />}
    </Tracker>
);

export default Image;
